import React from 'react';
import { useSelector } from 'react-redux';
import FeedbackProtect from './FeedbackProtect';
import FeedbackForm from './FeedbackForm';

function ProtectedFeedbackForm() {
    const isProtected = useSelector((state) => state.auth?.protect);

    return (
        <>
            {!isProtected ? (
                <FeedbackProtect />
            ) : (
                <FeedbackForm />
            )}
        </>
    );
}

export default ProtectedFeedbackForm; 